import { uiOptions } from '@/config'

export function removeModalId(modalId: string) {
  delete uiOptions().isModalOpen[modalId]
}
